
import React from 'react';

/**
 * Component for navigation.
 */
class Navigate extends React.Component {

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.path) {
      if (nextProps.push) {
        nextProps.history.replace(nextProps.path);
      } else {
        nextProps.history.push(nextProps.path);
      }
      this.props.navigatePath(null);
    }
  }

  render() {
    return (<div></div>);
  }
}

export default Navigate;
